import React from 'react';

import LoginUser from '../components/container/LoginUser';

const Login = () => {
  return <LoginUser />;
};

export default Login;
